import { render, staticRenderFns } from "./DashboardPublic.vue?vue&type=template&id=9fdda4a0&scoped=true"
import script from "./DashboardPublic.vue?vue&type=script&lang=js"
export * from "./DashboardPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdda4a0",
  null
  
)

export default component.exports